/**
 * Build query params string from URLSearchParams
 * Check if value is empty and remove it from query params
 * @param {URLSearchParams | undefined} queryParams - URLSearchParams object
 */
export default function buildQueryParams(
  queryParams: URLSearchParams | undefined
): string {
  if (!queryParams) return '';

  Array.from(queryParams.entries()).forEach(([key, value]) => {
    if (value === '') {
      queryParams.delete(key);
    }
  });

  return `?${queryParams.toString()}`;
}
